import { CompanyCard, CompanyCardStatus, TachographCompanyCardRow } from "../models/Tachograph";
import { formatDateTime, formatUtcDate, parseDateOrNull } from "./tachographDates";

export function normalizeCompanyCardStatus(value?: string): CompanyCardStatus {
  const normalized = value?.trim().toLowerCase();
  if (normalized === "busy") return "busy";
  if (normalized === "offline") return "offline";

  return "available";
}

type CompanyCardRowOptions = {
  search: string;
  language: string;
  formatStatus: (status: CompanyCardStatus) => string;
};

/** The rows of the company card tab: only cards in use, sorted by card number. */
export function buildCompanyCardRows(
  cards: CompanyCard[],
  { search, language, formatStatus }: CompanyCardRowOptions,
): TachographCompanyCardRow[] {
  const normalizedSearch = search.trim().toLowerCase();

  return cards
    .filter(card => normalizeCompanyCardStatus(card.status) === "available")
    .filter(card => {
      if (!normalizedSearch) return true;

      const haystack = `${card.cardNumber ?? ""} ${card.companyName ?? ""} ${card.source ?? ""}`.toLowerCase();

      return haystack.includes(normalizedSearch);
    })
    .map(card => {
      const validity = parseDateOrNull(card.validity);
      const expiry = parseDateOrNull(card.expiry);
      const lastUpdate = parseDateOrNull(card.lastUpdate);

      return {
        id: card.id ?? card.cardNumber ?? `${card.companyName ?? "company"}-${card.icc ?? "icc"}`,
        cardNumber: card.cardNumber ?? "",
        companyName: card.companyName ?? "",
        icc: card.icc != null ? String(card.icc) : "",
        status: formatStatus(normalizeCompanyCardStatus(card.status)),
        source: card.source ?? "",
        validFrom: validity ? formatUtcDate(validity) : "",
        expiryDateUtc: expiry ? formatUtcDate(expiry) : "",
        lastUpdate: lastUpdate ? formatDateTime(lastUpdate, language) : "",
      };
    })
    .sort((a, b) => a.cardNumber.localeCompare(b.cardNumber));
}
